import { type FormEvent, useState } from "react";
import { Seo } from "../components/Seo";
import { hasContactDetails, hasText, site } from "../config/site";

export function ContactPage() {
  const [status, setStatus] = useState("");
  const emailReady = hasText(site.contact.email);

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!emailReady) {
      return;
    }

    const form = event.currentTarget;
    const data = new FormData(form);
    const name = String(data.get("name") ?? "").trim();
    const email = String(data.get("email") ?? "").trim();
    const message = String(data.get("message") ?? "").trim();
    const subject = encodeURIComponent(`Message from ${name || "the website"}`);
    const body = encodeURIComponent(`${message}\n\nFrom: ${name} <${email}>`);
    window.location.href = `mailto:${site.contact.email}?subject=${subject}&body=${body}`;
    setStatus(
      "Your email application should open with this message. If it does not, write to us at the address above."
    );
  }

  return (
    <main id="main" className="page">
      <Seo
        title="Contact"
        description="Contact Beautiful Jewellery."
        path="/contact"
      />
      <p className="kicker">Contact</p>
      <h1>Contact</h1>
      {hasContactDetails() ? (
        <>
          <p className="lede">We would like to hear from you.</p>
          <div className="section">
            {emailReady ? (
              <p>
                Email{" "}
                <a href={`mailto:${site.contact.email}`}>{site.contact.email}</a>
              </p>
            ) : null}
            {hasText(site.contact.phone) ? <p>Telephone {site.contact.phone}</p> : null}
            {hasText(site.contact.hours) ? <p>{site.contact.hours}</p> : null}
          </div>
          {emailReady ? (
            <form className="form-grid section" onSubmit={handleSubmit}>
              <label>
                <span>Name</span>
                <input name="name" type="text" autoComplete="name" />
              </label>
              <label>
                <span>Your email</span>
                <input name="email" type="email" autoComplete="email" required />
              </label>
              <label>
                <span>Message</span>
                <textarea name="message" required />
              </label>
              <button className="button" type="submit">
                Open email message
              </button>
              {status ? <p role="status">{status}</p> : null}
            </form>
          ) : null}
        </>
      ) : (
        <p className="lede">
          We will share a way to write to us when the collection is ready.
        </p>
      )}
    </main>
  );
}
